export const NoResponse = 'NoResponse';
export const Accepted = 'Accepted';
export const Declined = 'Declined';
export const Visited = 'Visited';
export const Waitlisted = 'Waitlisted';
export const Cancelled = 'Cancelled';
export const PendingApproval = 'PendingApproval';
export const DeniedApproval = 'DeniedApproval';

export const InviteeStatusId = {
  NoResponse: 1,
  Accepted: 2,
  Declined: 3,
  Visited: 4,
  Waitlisted: 6,
  Cancelled: 7,
  PendingApproval: 8,
  DeniedApproval: 9
};

export const InviteeStatusById = {
  1: NoResponse,
  2: Accepted,
  3: Declined,
  4: Visited,
  6: Waitlisted,
  7: Cancelled,
  8: PendingApproval,
  9: DeniedApproval
};
